import {createContext} from 'react';
import { io } from 'socket.io-client';
// Stejný origin, socket.io pod /pos-api (nginx-proxy prefix odstřihne → server
// vidí /socket.io). Lokální dev: http://host:port z .env.development.
const API_URL = process.env.REACT_APP_API_URL || '/pos-api';
const API_PORT = process.env.REACT_APP_API_PORT;
const hasScheme = /^https?:\/\//.test(API_URL);
const socketUrl = hasScheme && API_PORT ? `${API_URL}:${API_PORT}` : undefined;
const socketPath = hasScheme ? '/socket.io' : `${API_URL}/socket.io`;
export const socket = io(socketUrl, {
  path: socketPath,
  // websocket preferovaně; polling jako fallback, kdyby ws neprošlo přes proxy.
  transports: ["websocket", "polling"],
  auth: {
    token: '123321654456stolArna',
  }
});

socket.on('connect', () => {
  console.log('Připojeno k serveru');
});

socket.on('disconnect', () => {
  console.log('Odpojeno od serveru');
});

socket.on('connect_error', (error) => {
  console.log('Chyba připojení:', error);
});


const socketContext = createContext({});
export default socketContext;
